/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit HtmlFile/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import EditableTextArea from 'DesignSystem/EditableTextArea/react'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function HtmlFile({
  children,
  viewPath = "/DesignSystem/PreviewResource/Content/Content/HtmlFile"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let resourcePreviewUrlValueData = fromData.useDataValue({ viewPath,
context: 'resource',
path: 'preview_url',
})
  return (<React.Fragment
>
<div
  data-testid="HtmlFile.Vertical"
  data-view-path={viewPath}
 style={{'--pt-1-ZjHxnX': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<EditableTextArea
  viewPath={`${viewPath}/EditableTextArea`}
 data="resource.preview_url"
 value={resourcePreviewUrlValueData}
/>
</div>
{children}
</React.Fragment>)
}